import { CartDiscountType } from '../../../../hooks/useCartDiscountsQuery/types.js';
import 'react';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '../../../../types/product.js';
import { isNonRecoverableError, isRecoverableError, isNonExecutableQueryError } from '../../../../types/typeguards.js';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../slots/context.js';
import '@grandvisionhq/content';
import { isWithoutRx, isWithRx } from '../../components/RxableSelect/is-rx-radio-selection.js';
import { isNoRxEntry, isRxEntryOptional, isRxEntryRequired } from '../types/typeguards.js';
import { mapContactLensesToDraftLineItems } from '../utils/map-contact-lenses-to-draft-line-items.js';

const columnsIsNonOrderable = (column)=>{
    return column.isEnabled && column.quantitySelector.maxSelectableQuantity === 0;
};
const getConfiguratorType = (state)=>{
    const { rxEntryType  } = state.configurator;
    const { rxToggle  } = state.configurations;
    if (isNoRxEntry(rxEntryType) || isRxEntryOptional(rxEntryType) && isWithoutRx(rxToggle)) {
        return 'one-column';
    }
    if (isRxEntryRequired(rxEntryType) || isRxEntryOptional(rxEntryType) && isWithRx(rxToggle)) {
        return 'two-column';
    }
    // Default to two-column configurator
    return 'two-column';
};
const isOneColConfigurator = (state)=>{
    return getConfiguratorType(state) === 'one-column';
};
const hasNonOrderableProduct = (state)=>{
    /**
   * For the ContactLensesEcommState, a product is considered non orderable if they have an
   * available quantity of 0 and are not back orderable. If this is the case, the maxSelectableQuantity
   * will also be 0.
   */ if (isOneColConfigurator(state)) {
        return columnsIsNonOrderable(state.configurator.both);
    }
    return columnsIsNonOrderable(state.configurator.left) || columnsIsNonOrderable(state.configurator.right);
};
const hasNonRecoverableErrorOnEyeside = (state, eyeSide)=>{
    const { configurator , queries  } = state;
    return configurator[eyeSide].isEnabled && isNonRecoverableError(queries[eyeSide].error);
};
const hasNonRecoverableError = (state)=>{
    if (isOneColConfigurator(state)) {
        return hasNonRecoverableErrorOnEyeside(state, 'both');
    }
    return hasNonRecoverableErrorOnEyeside(state, 'left') || hasNonRecoverableErrorOnEyeside(state, 'right');
};
const hasRecoverableErrorOnEyeside = (state, eyeSide)=>{
    const { configurator , queries  } = state;
    return configurator[eyeSide].isEnabled && isRecoverableError(queries[eyeSide].error);
};
const hasRecoverableError = (state)=>{
    if (isOneColConfigurator(state)) {
        return hasRecoverableErrorOnEyeside(state, 'both');
    }
    return hasRecoverableErrorOnEyeside(state, 'left') || hasRecoverableErrorOnEyeside(state, 'right');
};
const hasNonExecutableErrorOnEyeside = (state, eyeSide)=>{
    const { configurator , queries  } = state;
    return configurator[eyeSide].isEnabled && isNonExecutableQueryError(queries[eyeSide].error);
};
const hasNonExecutableQueryError = (state)=>{
    if (isOneColConfigurator(state)) {
        return hasNonExecutableErrorOnEyeside(state, 'both');
    }
    return hasNonExecutableErrorOnEyeside(state, 'left') || hasNonExecutableErrorOnEyeside(state, 'right');
};
const hasQueryError = (state)=>{
    return hasNonRecoverableError(state) || hasRecoverableError(state);
};
const hasQueryLoading = (state)=>{
    if (isOneColConfigurator(state)) {
        return state.queries.both.loading;
    }
    return state.queries.left.loading || state.queries.right.loading;
};
const getEnabledSelectedQuantity = (state)=>{
    const { configurator , configurations  } = state;
    if (isOneColConfigurator(state)) {
        return configurations.both.quantity;
    }
    if (!configurator.columnCheckboxes.areValid) {
        // if both checkboxes are unselected, then the quantity selectors are disabled and there is no selected quantity
        return null;
    }
    const { left: { quantity: leftQuantity  } , right: { quantity: rightQuantity  } ,  } = configurations;
    const { left: leftColumn , right: rightColumn  } = configurator;
    // If only right side is enabled, return right quantity
    if (!leftColumn.isEnabled) {
        return rightQuantity;
    }
    // If only left side is enabled, return left quantity
    if (!rightColumn.isEnabled) {
        return leftQuantity;
    }
    return leftQuantity + rightQuantity;
};
const getLineItemDrafts = (state, priceSegmentChannelKey)=>{
    if (hasQueryError(state)) {
        return [];
    }
    return mapContactLensesToDraftLineItems(state, isOneColConfigurator(state), priceSegmentChannelKey);
};
const getCartDiscountUnitPrice = (unitPrice, cartDiscount)=>{
    if (!cartDiscount) {
        return 0;
    }
    const { type , amount  } = cartDiscount;
    if (type === CartDiscountType.PERCENT) {
        const discount = unitPrice * amount / 100;
        return unitPrice - discount;
    }
    // The discount is a fixed amount
    return unitPrice - amount;
};
const getPricedQuantities = (totalQuantity, cartDiscount)=>{
    if (!cartDiscount) {
        return {
            regularPricedQuantity: totalQuantity,
            cartDiscountedPricedQuantity: 0
        };
    }
    const regularPricedQuantity = totalQuantity % cartDiscount.minimumQuantity;
    const cartDiscountedPricedQuantity = totalQuantity - regularPricedQuantity;
    return {
        regularPricedQuantity,
        cartDiscountedPricedQuantity
    };
};
const getTotalPurchasePrice = (state, displayPrice, cartDiscount)=>{
    const totalQuantity = getEnabledSelectedQuantity(state);
    if (!totalQuantity) {
        return undefined;
    }
    var _discountedPrice;
    const unitPrice = (_discountedPrice = displayPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : displayPrice.originalPrice;
    if (cartDiscount) {
        const cartDiscountUnitPrice = getCartDiscountUnitPrice(unitPrice, cartDiscount === null || cartDiscount === void 0 ? void 0 : cartDiscount.discount);
        const { regularPricedQuantity , cartDiscountedPricedQuantity  } = getPricedQuantities(totalQuantity, cartDiscount);
        return regularPricedQuantity * unitPrice + cartDiscountedPricedQuantity * cartDiscountUnitPrice;
    }
    return totalQuantity * unitPrice;
};
const getSelectors = ()=>{
    return {
        hasNonOrderableProduct,
        hasNonRecoverableError,
        hasNonRecoverableErrorOnEyeside,
        hasNonExecutableQueryError,
        hasRecoverableErrorOnEyeside,
        hasRecoverableError,
        hasQueryError,
        hasQueryLoading,
        isOneColConfigurator,
        getConfiguratorType,
        getEnabledSelectedQuantity,
        getLineItemDrafts,
        getTotalPurchasePrice
    };
};

export { getSelectors };
//# sourceMappingURL=selectors.js.map
